import { createEntityAdapter } from '@reduxjs/toolkit';

import { IFeedItem } from 'api/feed/types';

export const adapter = createEntityAdapter<IFeedItem>({
  selectId: (item) => item.feedItemId as string,
});
